"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FIELD_WRAPPER_STYLE = exports.FIELD_WRAPPER_LABEL_STYLE = exports.FIELD_WRAPPER_FONT = void 0;
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FIELD_WRAPPER_STYLE = exports.FIELD_WRAPPER_STYLE = {
  paddingTop: "16px"
};
const FIELD_WRAPPER_FONT = exports.FIELD_WRAPPER_FONT = {
  ..._alloyReactTheme.default.typography.labelSmall,
  color: _alloyReactTheme.default.colors.charcoal700
};
const FIELD_WRAPPER_LABEL_STYLE = exports.FIELD_WRAPPER_LABEL_STYLE = {
  ...FIELD_WRAPPER_FONT,
  paddingBottom: "6px",
  display: "flex",
  alignItems: "center"
};
//# sourceMappingURL=consts.js.map